import { CommandType } from "../../../../common/services/cqs/CommandType";
import { AtgardBaseCommand } from "./AtgardBaseCommand";

export class ResetSlutjusteraAtgardCommand extends AtgardBaseCommand {
    atgardGuid: string;
    static readonly $type = "ResetSlutjusteraAtgardCommand";

    constructor(atgardGuid: string) {
        super(ResetSlutjusteraAtgardCommand.$type, CommandType.Replace);
        this.atgardGuid = atgardGuid;
    }
}
